import { ENDPOINTS } from "@/constants/endpoints";
import { api } from "../network/api";
import type {
  EmployerUpdateRequestSubmissionDto,
  EmployerUpdateRequestPreCheckResponse,
} from "@/models/dto/employer-update-request.dto";
import type { BaseResponse } from "@/models/responses/base/baseResponse.response";

const EmployerUpdateRequestService = {
  submit: async function (
    dto: EmployerUpdateRequestSubmissionDto,
    authenticated: boolean
  ): Promise<BaseResponse<{ id: string; status: string }>> {
    const url = authenticated
      ? ENDPOINTS.EMPLOYER_UPDATE_REQUEST.SUBMIT
      : ENDPOINTS.EMPLOYER_UPDATE_REQUEST.SUBMIT_ONBOARDING;
    const response = await api.post(url, dto);
    return response as unknown as BaseResponse<{ id: string; status: string }>;
  },

  preCheck: async function (
    employerCode: string
  ): Promise<EmployerUpdateRequestPreCheckResponse> {
    const response = await api.get(ENDPOINTS.EMPLOYER_UPDATE_REQUEST.PRE_CHECK, {
      params: { employerCode },
    });
    const body = response as unknown as BaseResponse<EmployerUpdateRequestPreCheckResponse>;
    if (!body?.data) {
      throw new Error("Unable to check your update request status.");
    }
    return body.data;
  },
};

export default EmployerUpdateRequestService;
